module.exports = __webpack_public_path__ + "media/images/countryrect/sb-c349273414c970f9df1fc793dc0ca4ac.svg";